// RightPanel (DESIGN §2): 300px column at the right edge of the window on ≥1280px; 1100–1279px (and below) its
// content flows under the page content. Pages never render it directly — pass content via <Page aside={…}>.
import './right-panel.css';
import { cx } from './ui.jsx';

export function RightPanel({ label = 'Details', class: cls, children }) {
  return (
    <aside class={cx('right-panel', cls)} aria-label={label}>
      {children}
    </aside>
  );
}

// One titled block inside the right panel (e.g. TODAY, UPCOMING). `action`: small link/button at the right.
export function RightPanelSection({ title, action, empty, class: cls, children }) {
  const hasContent = Array.isArray(children) ? children.some(Boolean) : !!children;
  return (
    <section class={cx('rp-section', cls)}>
      {(title || action) && (
        <div class="rp-head">
          {title && <h2 class="rp-title">{title}</h2>}
          {action}
        </div>
      )}
      {hasContent ? children : empty && <p class="rp-empty">{empty}</p>}
    </section>
  );
}
